import { motion } from "framer-motion";
import { Utensils, Flame, Users } from "lucide-react";

export default function Events() {
  const services = [
    {
      title: "מגשי אוכל",
      description:
        "מגשי אירוח עשירים ומוקפדים – בשרי / פרווה, בהתאמה אישית לאופי האירוע.",
      icon: <Utensils className="w-8 h-8" />,
    },
    {
      title: "הכנת ספינג' במקום",
      description:
        "חוויה מרוקאית חמה ומתוקה – ספינג' טרי שמטוגן במקום ומוגש חם לאורחים.",
      icon: <Flame className="w-8 h-8" />,
    },
    {
      title: "מופלטות במקום",
      description:
        "מופלטות בעבודת יד, עם חמאה ודבש – חוויה שמחברת אנשים.",
      icon: <Users className="w-8 h-8" />,
    },
  ];

  return (
    <section className="py-16 px-4 max-w-6xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-3xl md:text-4xl font-bold text-center mb-12"
      >
        שירותים לאירועים
      </motion.h2>

      <div className="grid md:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="h-full rounded-2xl shadow-md border bg-white"
          >
            <div className="p-6 flex flex-col items-center text-center gap-4">
              <div className="p-4 rounded-full bg-gray-100">{service.icon}</div>
              <h3 className="text-xl font-semibold">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <button className="rounded-2xl px-8 py-3 font-semibold shadow-md border bg-black text-white hover:opacity-90">
          להזמנת אירוע
        </button>
      </div>
    </section>
  );
}
